import script from "./ListaInstituciones.vue?vue&type=script&setup=true&lang=js"
export * from "./ListaInstituciones.vue?vue&type=script&setup=true&lang=js"

import "./ListaInstituciones.vue?vue&type=style&index=0&id=69b418f9&lang=css"

const __exports__ = script;

export default __exports__